import { Flame } from 'lucide-react';

interface SpicinessBadgeProps {
  level: number;
  size?: 'sm' | 'md' | 'lg';
}

const LABELS: Record<number, string> = {
  1: '微辣',
  2: '小辣',
  3: '中辣',
  4: '大辣',
  5: '地獄辣',
};

export default function SpicinessBadge({ level, size = 'md' }: SpicinessBadgeProps) {
  if (!level || level <= 0) return null; // 非辣商品（spiciness_level=0）不顯示辣度徽章
  const safeLevel = Math.min(5, Math.max(1, level));
  const label = LABELS[safeLevel] || '微辣';

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs gap-1',
    md: 'px-3 py-1 text-sm gap-1.5',
    lg: 'px-4 py-1.5 text-base gap-2',
  };

  const flameSizes = {
    sm: 12,
    md: 16,
    lg: 20,
  };

  const colors = [
    'bg-green-100 text-green-700',
    'bg-lime-100 text-lime-700',
    'bg-yellow-100 text-yellow-700',
    'bg-orange-100 text-orange-700',
    'bg-red-100 text-red-700',
  ];

  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold ${sizeClasses[size]} ${colors[safeLevel - 1]}`}
    >
      <Flame size={flameSizes[size]} className="text-x1493-primary" />
      {label}
    </span>
  );
}
